module.exports = __webpack_public_path__ + "img/US_BonusDamagevsSiege_ua.d7791659.webp";